import { initiateGoogleBrandSignup } from '@/libs/oauth-utils';
import { Button } from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GoogleIcon } from './GoogleSignInButton';
import { productAnalytics } from '@/libs/product-analytics';

interface GoogleSignUpButtonProps {
  /** The admin invitation to accept; without one the brand signs up on its own. */
  invitationToken?: string;
}

export const GoogleSignUpButton: React.FC<GoogleSignUpButtonProps> = ({ invitationToken }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    productAnalytics.capture('authentication_started', {
      feature: 'authentication',
      action: 'create',
      entry_point: 'google',
    });
    setIsLoading(true);
    initiateGoogleBrandSignup(invitationToken);
  };

  return (
    <Button
      onClick={handleClick}
      variant="outline"
      width="full"
      borderRadius="12px"
      h={{ base: '44px', md: '48px' }}
      bg="white"
      borderColor="gray.200"
      _hover={{ bg: 'gray.50', borderColor: 'gray.400' }}
      color="primary.900"
      fontSize={{ base: '14px', md: '15px' }}
      fontWeight="medium"
      loading={isLoading}
      loadingText={t('auth.redirectingToGoogle')}
      disabled={isLoading}
      gap={2}
      display="flex"
      alignItems="center"
    >
      {!isLoading && <GoogleIcon />}
      {t('auth.signUpWithGoogle')}
    </Button>
  );
};
